import React, { useEffect } from 'react';
import { restoreSession, useAuth } from '../services/auth';
import Login, { SetPassword } from '../pages/Login/Login';

// Staff must be signed in to see the app. (Customer report links don't pass through here.)
const AuthGate = ({ children }) => {
  const { status, user, linkType } = useAuth();

  useEffect(() => {
    restoreSession();
  }, []);

  if (status === 'loading') return <div className="auth-loading" aria-label="Loading" />;
  if (status === 'signedOut') return <Login />;
  if (status === 'setPassword') return <SetPassword user={user} linkType={linkType} />;
  // keyed by user so nothing from one person's session carries into the next
  return <React.Fragment key={user.id}>{children}</React.Fragment>;
};

export default AuthGate;
